<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="label">{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="constraintData.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="code">{{ $t('page.generic.code') }} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" disabled id="code" v-model="constraintData.code" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $t('page.generic.codingSchema') }} <required-field /></label>
                <v-select :class="errors.some((e) => e.field === 'procedureAndPatientDetailCodingSchema') ? 'error' :''" v-model="constraintData.patientConstraintCodingSchema" :options="codingSchema.data"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="descriptionField" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="constraintData.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="updatePatientDetails">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'patientConstraintRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import PatientConstraintService from '@/services/PatientConstraintService'
  import PatientConstraintCodingSchemaService from '@/services/PatientConstraintCodingSchemaService'
  import vSelect from 'vue-select'
  import RequiredField from "../../components/RequiredField";

  const patientConstraintService = PatientConstraintService.build();
  const patientConstraintCodingSchemaService = PatientConstraintCodingSchemaService.build();

  export default {
    name: 'constraintEdit',
    components: {
      RequiredField,
      PageTitle,
      vSelect
    },
    props: {
      id: {
        required: true
      }
    },
    data() {
      return {
        constraintData: {},
        errors: [],
        codingSchema: []
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
      this.getCodingSchema();
      this.fetchData();
    },
    methods: {
      async getCodingSchema() {
        this.codingSchema = await patientConstraintCodingSchemaService.search({});
      },
      async fetchData() {
        this.constraintData = await patientConstraintService.read(this.id);
      },
      async updatePatientDetails() {
        try {
          let constraints = await patientConstraintService.update(this.constraintData);
          this.$router.push({name: `patientConstraintShowRoute`, params: {id: constraints.id}})
        } catch (exception) {
          this.errors = exception.errors;
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }
      }
    }
  }
</script>
<style>
  .error > .clearfix{
    border: 1px solid #f3464a
  }
</style>
